import httpWrapper from '../HttpWrapper'
import {
    SearchWorkHistoryCsParams,
    SearchWorkHistoryCsRes,
} from './models/WorkHistoryCsDtos'

class WorkHistoryApi {
    private static instance: WorkHistoryApi

    public constructor() {
        if (WorkHistoryApi.instance) {
            return WorkHistoryApi.instance
        }

        WorkHistoryApi.instance = this
    }

    public async searchWorkHistoryCs(
        params: SearchWorkHistoryCsParams = {},
    ): Promise<SearchWorkHistoryCsRes> {
        const queryParams = new URLSearchParams()
        if (params.q && params.q.trim()) {
            queryParams.set('q', params.q.trim())
        }
        if (params.pageNumber) {
            queryParams.set('pageNumber', String(params.pageNumber))
        }
        if (params.perPage) {
            queryParams.set('perPage', String(params.perPage))
        }
        if (
            params.companyEntityFilter &&
            params.companyEntityFilter !== 'all'
        ) {
            queryParams.set('companyEntityFilter', params.companyEntityFilter)
        }
        return await httpWrapper.get<SearchWorkHistoryCsRes>(
            '/work-history-cs/search',
            queryParams,
        )
    }
}

const workHistoryApi = new WorkHistoryApi()

export default workHistoryApi
